"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFullReturn = exports.isCancelled = exports.getTitle = exports.getTimezone = exports.getReturnTitle = exports.getReturnText = exports.getReturnHeader = exports.getPriceText = exports.getListItemDateText = exports.getIntervaledStages = exports.getInsuranceButtonText = exports.getFadeColors = exports.getDescriptionStagesText = exports.getCurrentStage = exports.getCollapsedTitleContent = exports.getCancelledText = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _differenceInHours = _interopRequireDefault(require("date-fns/differenceInHours"));
var _subDays = _interopRequireDefault(require("date-fns/subDays"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _isEqual = _interopRequireDefault(require("date-fns/isEqual"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _localization = require("@lt/localization");
var _currency = require("../../../utils/currency");
var _date = require("../../../utils/date");
var _number = require("../../../utils/number");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var rgbaToString = function rgbaToString(color, alpha) {
  return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(alpha, ")");
};
var getFadeColors = exports.getFadeColors = function getFadeColors(baseColor, count) {
  var alphaStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var alphaStop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.05;
  if (!count) {
    return [];
  }
  var alphaStep = (0, _number.toDecimal)((alphaStart - alphaStop) / count);
  var colorArray = [];
  for (var i = 0; i < count; i += 1) {
    var alpha = (0, _number.toDecimal)(alphaStart - i * alphaStep);
    var strColor = rgbaToString(baseColor, alpha < alphaStop ? alphaStop : alpha);
    colorArray.push(strColor);
  }
  return colorArray;
};
var isFullReturn = exports.isFullReturn = function isFullReturn(type) {
  return type === 'full';
};
var getReturnTitle = exports.getReturnTitle = function getReturnTitle(price, interval) {
  if (price === 0) {
    return '';
  }
  var dateText = (0, _date.formatDate)(interval.endDateISO, 'd MMM H:mm');
  return "".concat(_localization.i18n.t('filters.prices.before'), " ").concat(dateText);
};
var getReturnText = exports.getReturnText = function getReturnText(price, interval, fullReturn, isHotelOnly) {
  var endDateText = "".concat((0, _date.formatDate)(new Date(interval.endDateISO), 'd MMMM, HH:mm'), " ").concat(_localization.i18n.t('cancellationPolicy.timezone'), " ").concat(getTimezone(new Date(interval.endDateISO)));
  var startDateText = "".concat((0, _date.formatDate)(new Date(interval.startDateISO), 'd MMMM, HH:mm'), " ").concat(_localization.i18n.t('cancellationPolicy.timezone'), " ").concat(getTimezone(new Date(interval.startDateISO)));
  var offerType = _localization.i18n.t('cancellationPolicy.offerType', {
    context: isHotelOnly ? 'hotel' : 'package'
  });
  var tourRules = _localization.i18n.t('cancellationPolicy.tourRules', {
    context: isHotelOnly ? 'hotel' : 'package'
  });
  if (price === 0) {
    return _localization.i18n.t('cancellationPolicy.returnText_startDate', {
      startDateText: startDateText,
      offerType: offerType,
      tourRules: tourRules
    });
  }
  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.returnText_full', {
      endDateText: endDateText,
      price: price,
      offerType: offerType
    });
  }
  return _localization.i18n.t('cancellationPolicy.returnText_endDate', {
    endDateText: endDateText,
    price: price,
    offerType: offerType,
    tourRules: tourRules
  });
};
var getDescriptionStagesText = exports.getDescriptionStagesText = function getDescriptionStagesText(price, interval, fullReturn, isHotelOnly) {
  var format = isHotelOnly ? 'd MMMM yyyy г., HH:mm' : 'd MMMM yyyy г.';
  var endDateText = (0, _date.formatDate)(interval.endDateISO, format);
  var startDateText = (0, _date.formatDate)(interval.startDateISO, format);
  if (price === 0) {
    return _localization.i18n.t('tariff.cancellationPolicy.nothing', {
      startDateText: startDateText
    });
  }
  if (fullReturn) {
    return "".concat(_localization.i18n.t('tariff.cancellationPolicy.full', {
      endDateText: endDateText
    }), " ").concat(getTimezone(new Date(interval.endDateISO)));
  }
  return "".concat(_localization.i18n.t('tariff.cancellationPolicy.partial', {
    endDateText: endDateText
  }), " ").concat(getTimezone(new Date(interval.endDateISO)));
};
var getReturnHeader = exports.getReturnHeader = function getReturnHeader(price, fullReturn) {
  if (price === 0) {
    return _localization.i18n.t('cancellationPolicy.noReturn');
  }
  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.fullReturn');
  }
  return _localization.i18n.t('cancellationPolicy.partialReturn');
};
var getPriceText = exports.getPriceText = function getPriceText(price, fullReturn) {
  if (price === 0) {
    return '0 ₽';
  }
  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.fullReturn');
  }
  return "".concat((0, _currency.formatCurrency)(price));
};
var getProgress = function getProgress(startDate, endDate, nowDate) {
  if (!(0, _isValid["default"])(startDate) || !(0, _isValid["default"])(endDate) || !(0, _isValid["default"])(nowDate)) {
    return 0;
  }
  if ((0, _isAfter["default"])(nowDate, endDate)) {
    return 0;
  }
  if ((0, _isBefore["default"])(nowDate, startDate)) {
    return 100;
  }
  var wholeIntervalDays = (0, _differenceInHours["default"])(endDate, startDate);
  var nowIntervalDays = (0, _differenceInHours["default"])(nowDate, startDate);
  return 100 - Math.round(nowIntervalDays / wholeIntervalDays * 100);
};
var getHasNowDateFlag = function getHasNowDateFlag(startDate, endDate, nowDate, index) {
  return (0, _isValid["default"])(startDate) && (0, _isValid["default"])(endDate) && (0, _isBefore["default"])(startDate, endDate) && !(0, _isEqual["default"])(nowDate, endDate) && ((0, _isWithinInterval["default"])(nowDate, {
    start: startDate,
    end: endDate
  }) || index === 0 && (0, _isBefore["default"])(nowDate, startDate));
};
var getIntervaledStages = exports.getIntervaledStages = function getIntervaledStages() {
  var stages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var flightDateISO = arguments.length > 1 ? arguments[1] : undefined;
  var nowDateISO = arguments.length > 2 ? arguments[2] : undefined;
  return stages.map(function (stage, index) {
    var _stages;
    var interval = {
      startDateISO: stage.start_date,
      endDateISO: ((_stages = stages[index + 1]) === null || _stages === void 0 ? void 0 : _stages.start_date) || flightDateISO
    };
    var startDate = new Date(interval.startDateISO);
    var endDate = new Date(interval.endDateISO);
    var nowDate = new Date(nowDateISO);
    var progress = getProgress(startDate, endDate, nowDate);
    var hasNowDate = getHasNowDateFlag(startDate, endDate, nowDate, index);
    return _objectSpread(_objectSpread({}, stage), {}, {
      interval: interval,
      progress: progress,
      hasNowDate: hasNowDate
    });
  });
};
var getListItemDateText = exports.getListItemDateText = function getListItemDateText(interval, flightDateISO, isHotelOnly, first) {
  var startDateISO = interval.startDateISO,
    endDateISO = interval.endDateISO;
  var isEndDateFlight = new Date(flightDateISO) === new Date(endDateISO);
  var displayStartDate = (0, _parseISO["default"])(startDateISO);
  var displayEndDate = isHotelOnly || isEndDateFlight || first ? (0, _parseISO["default"])(endDateISO) : (0, _subDays["default"])((0, _parseISO["default"])(endDateISO), 1);
  var format = isHotelOnly ? 'd MMM H:mm' : 'd MMM';
  var dateStartText = (0, _date.formatDate)(displayStartDate, format);
  var dateEndText = (0, _date.formatDate)(displayEndDate, format);
  var isDatesEqual = (0, _isEqual["default"])(new Date(dateStartText), new Date(dateEndText));
  var endDateIsBefore = (0, _isBefore["default"])(displayEndDate, displayStartDate);
  if (endDateIsBefore) {
    return "".concat(_localization.i18n.t('cancellationPolicy.after'), " ").concat(dateStartText);
  }
  if (isDatesEqual) {
    return dateStartText;
  }
  if (first) return "".concat(_localization.i18n.t('filters.prices.before'), " ").concat(dateEndText);
  return "".concat(dateStartText, " \u2013 ").concat(dateEndText);
};
var getInsuranceButtonText = exports.getInsuranceButtonText = function getInsuranceButtonText() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var insuranceSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return insuranceSelected ? "".concat(_localization.i18n.t('cancellationPolicy.insuranceRemove_desktop')) : "".concat(_localization.i18n.t('cancellationPolicy.insuranceAdd_desktop'), " ").concat((0, _currency.formatCurrency)(price));
};
var getCancelledText = exports.getCancelledText = function getCancelledText(cancellationDateISO) {
  var date = (0, _parseISO["default"])(cancellationDateISO);
  if (!(0, _isValid["default"])(date)) {
    return '';
  }
  return "".concat(_localization.i18n.t('cancellationPolicy.canceled'), " ").concat((0, _date.formatDate)(date, 'd MMM yyyy'));
};
var isCancelled = exports.isCancelled = function isCancelled(dateISO) {
  return dateISO ? (0, _isValid["default"])((0, _parseISO["default"])(dateISO)) : false;
};
var getCollapsedTitleContent = exports.getCollapsedTitleContent = function getCollapsedTitleContent(isMobile, isHotelOnly, returnType, currentStageEndDate, cancelled) {
  if (cancelled) return _localization.i18n.t('cancellationPolicy.tourCanceled', {
    context: isHotelOnly ? 'hotel' : 'package'
  });
  var formatDeviceDate = isMobile ? 'd MMM, HH:mm' : 'd MMMM, HH:mm';
  switch (returnType) {
    case 'full':
      return "".concat(_localization.i18n.t('cancellationPolicy.freeCancellation'), " ").concat((0, _date.formatDate)(new Date(currentStageEndDate), formatDeviceDate), " ").concat(getTimezone(new Date(currentStageEndDate)));
    case 'partial':
      return _localization.i18n.t('cancellationPolicy.partialRefund');
    case 'nothing':
      return _localization.i18n.t('cancellationPolicy.nonRefundableTour', {
        context: isHotelOnly ? 'hotel' : 'package'
      });
    default:
      return null;
  }
};
var getCurrentStage = exports.getCurrentStage = function getCurrentStage(stages) {
  var currentStage = stages.filter(function (stage) {
    return stage.hasNowDate;
  }).length ? stages.filter(function (stage) {
    return stage.hasNowDate;
  }) : stages;
  if (currentStage === stages) {
    // проверяем за какие пределы выходит дата
    // @ts-ignore
    return (0, _isBefore["default"])(new Date(), new Date(stages[0].start_date)) ? stages[0] : stages[stages.length - 1];
  }
  return currentStage[0];
};
var getTitle = exports.getTitle = function getTitle(currentStage, isHotelOnly) {
  if (!currentStage) return '';
  if (currentStage.return_type === 'full') {
    var format = isHotelOnly ? 'd MMMM, HH:mm' : 'd MMMM';
    var formatEndDate = (0, _date.formatDate)(new Date(currentStage.end_date), format);
    return "".concat(_localization.i18n.t('cancellationPolicy.freeCancellation'), " ").concat(formatEndDate);
  }
  if (currentStage.return_type === 'partial') {
    return "".concat(_localization.i18n.t('cancellationPolicy.partialRefund'));
  }
  if (currentStage.return_type === 'nothing') {
    return "".concat(_localization.i18n.t('cancellationPolicy.nonRefundableTariff'));
  }
  return '';
};
var getTimezone = exports.getTimezone = function getTimezone(date) {
  var _date$toString$match;
  if (!date) return '';
  return "(".concat("".concat((_date$toString$match = date.toString().match(/([A-Z]+[+-][0-9].)/)) === null || _date$toString$match === void 0 ? void 0 : _date$toString$match[1], ".00"), ")");
};